import Container from "./Container";

export type { IContainerProps } from "./Container";

export default Container;
